/**
 * 초대 링크로 들어온 사람이 **로그인을 마치고 초대 화면으로 돌아오게** 한다.
 *
 * 왜 필요한가: 구글 로그인은 페이지를 떠났다가 돌아온다. 돌아올 주소를 우리가
 * 정해주지 않으면 Clerk 기본값(`/`)으로 가고, 초대 화면의 **"등록된 멤버 중
 * 본인을 선택하세요"를 영영 못 본다.** 그러면 주최자가 이름으로 등록해 둔
 * 멤버를 놔두고 새 멤버로 들어와 정산이 둘로 갈린다 — 2026-09-27에 실제로
 * 두 명에게 일어났다(`강영구` 옆에 `영구 강`이 생겼다).
 *
 * Clerk 쪽 리다이렉트 속성도 같이 지정하지만, 그건 Clerk 기본값에 기대는
 * 경로라 여기 저장분을 함께 둔다. sessionStorage는 같은 탭의 왕복에서 살아남고,
 * 탭을 닫으면 사라진다 — 초대 의도는 그 정도 수명이면 된다.
 */
const KEY = "gotravel:pending-invite";

export function rememberInvite(code: string): void {
  try {
    sessionStorage.setItem(KEY, code);
  } catch {
    // 시크릿 모드 등에서 막힐 수 있다. 막히면 Clerk 리다이렉트 속성만 남는다.
  }
}

/** 로그인 직후 가야 할 곳. 초대가 없으면 `/trips`. */
export function afterAuthPath(): string {
  try {
    const code = sessionStorage.getItem(KEY);
    if (code) return `/join/${encodeURIComponent(code)}`;
  } catch {
    // 무시 — 아래 기본값으로 간다.
  }
  return "/trips";
}

export function clearPendingInvite(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // 무시.
  }
}
